import { useEffect, useState } from 'react';
import EcoCountDown from 'eco-design-components/elements/eco-count-down';
import { useRouter } from 'next/router';
import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import { createPortal } from 'react-dom';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import { baseUrl } from 'lowcode/utils/service/baseUrl';
import { useProductCountdownEnd } from '../../ProductProvider';
import { useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import Modal from './Modal';
import ModalItems from './ModalItems';
import { getEmailConfigs } from './emailConfigs';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

interface ModalItem {
    title: string;
    lists: {
        img: string;
        name?: string;
        text: string;
    }[];
    tip: string;
    btn?: {
        btnText: string;
        btnLink?: string;
    };
}
interface ItemType {
    text: string;
    img: string[];
    modal: ModalItem;
    key: number;
}
const D: React.FC<{ setActivetedTabs: any }> = ({ setActivetedTabs }) => {
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-D');
    const pageStatus = useProductPageStatus();
    const { t } = useLang('dpux');
    const { locale = 'us' } = useRouter();
    const [input, setInput] = useState('');
    const [checked, setChecked] = useState(false);
    const [tip, setTip] = useState('');
    const [visible, setVisible] = useState(false);
    const [visibleItems, setVisibleItems] = useState(-1);
    const [isClient, setIsClient] = useState(false);
    const countDownEnd = useProductCountdownEnd();

    const termsMap: { [key: string]: string[] } = {
        us: ['https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html'],
        ca: ['https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html'],
        jp: ['https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'],
        eu: ['https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html'],
        uk: ['https://account.ecoflow.com/agreement/en-ul/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html'],
        de: ['https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/de-de/TermsOfUse.html'],
        fr: ['https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html'],
        it: ['https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/it-it/TermsOfUse.html'],
        es: ['https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/es-es/TermsOfUse.html'],
    };

    // 第一个阶段
    let items: ItemType[] = [
        {
            text: t(`D_item1_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737187/1.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000982471/pc_benifit_01.svg',
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001320599/768_light_%E4%BE%A7%E6%BB%91.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760001043076/m_benifit_01.svg',
            ],
            modal: {
                title: t(`D_item1_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153252/d_list1_1.png',
                        text: t(`D_item1_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item1_modal_tip_${pageStatus?.toLowerCase()}`),
                btn: {
                    btnText: t(`D_item1_modal_btn_text_${pageStatus?.toLowerCase()}`),
                    btnLink: t(`D_item1_modal_btn_link_${pageStatus?.toLowerCase()}`),
                },
            },
            key: 0,
        },
        {
            text: t(`D_item2_text_${pageStatus?.toLowerCase()}`),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760000982224/pc_benifit_02.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042485/m_benifit_02.svg',
            ],
            modal: {
                title: t(`D_item2_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153436/d_list3_1.png',
                        text: t(`D_item2_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item2_modal_tip_${pageStatus?.toLowerCase()}`),
                btn: {
                    btnText: t(`D_item2_modal_btn_text_${pageStatus?.toLowerCase()}`),
                    btnLink: t(`D_item2_modal_btn_link_${pageStatus?.toLowerCase()}`),
                },
            },
            key: 1,
        },
        {
            text: t(`D_item3_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737557/2.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000981994/pc_benifit_03.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042758/m_benifit_03.svg',
            ],
            modal: {
                title: t(`D_item3_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357214350/d_list2_1.png',
                        name: t(`D_item3_modal_name1_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item3_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153609/d_list2_2.png',
                        name: t(`D_item3_modal_name2_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item3_modal_text2_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item3_modal_tip_${pageStatus?.toLowerCase()}`),
            },
            key: 2,
        },
        {
            text: t(`D_item4_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737457/3.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000981748/pc_benifit_04.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042281/m_benifit_04.svg',
            ],
            modal: {
                title: t(`D_item4_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1757916708647/d4.svg',
                        name: t(`D_item4_modal_name1_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item4_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item4_modal_tip_${pageStatus?.toLowerCase()}`),
            },
            key: 3,
        },
    ];
    if (locale === 'ca') {
        items = [items[0], items[2], items[3]];
        items[1].modal.lists.shift();
    }

    // 第二个阶段
    if ([IPageStatus.SUPER_EARLY].includes(pageStatus)) {
        if (locale === 'ca') {
            items = [items[0], items[2]];
        } else {
            items[2].modal.lists[1].img = 'https://websiteoss.ecoflow.com/upload/image/1758357831874/d_list3_2.png';
            items[2].modal.lists.push({
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357832034/d_list3_3.png',
                name: t(`D_item3_modal_name3_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text3_${pageStatus?.toLowerCase()}`),
            });
        }
    }

    // 第三个阶段
    if (pageStatus === IPageStatus.EARLY) {
        items[2].modal.lists = [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357831874/d_list3_2.png',
                name: t(`D_item3_modal_name2_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text2_${pageStatus?.toLowerCase()}`),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357832034/d_list3_3.png',
                name: t(`D_item3_modal_name3_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text3_${pageStatus?.toLowerCase()}`),
            },
        ];
        items[2].img[0] = 'https://websiteoss.ecoflow.com/upload/image/1758356493927/768_light_1svg.svg';
        items[3].img[0] = 'https://websiteoss.ecoflow.com/upload/image/1758356493754/768_light_2.svg';
        items.shift();
        items.shift();
    }

    // 第四个阶段直接隐藏该模块

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value.trim());
    };

    const handleFoucus = () => {
        if ([t('D_tip_success'), t('D_tip_email_format'), t('D_tip_email_empty')].includes(tip)) {
            setTip('');
        }
    };

    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
        if ([t('D_tip_success'), t('D_tip_unchecked')].includes(tip)) {
            setTip('');
        }
        setChecked(e.target.checked);
    };

    const handleSubmit = async () => {
        const emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        const email = input.trim();
        if (!email) {
            return setTip(t('D_tip_email_empty'));
        }
        if (!emailReg.test(email)) {
            return setTip(t('D_tip_email_format'));
        }
        if (!checked) {
            return setTip(t('D_tip_unchecked'));
        }

        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        const emailConfig = getEmailConfigs(dateString);
        const { contactListId, fields } = emailConfig[locale as keyof typeof emailConfig] || emailConfig['us'];
        const res = await fetchPost(
            `${baseUrl(locale)}/subscribe/new`,
            locale,
            {
                contactListId: contactListId[0],
                email,
                fields,
                source: 'WEB_NEW_PRODUCT_SUB',
                otherContactListIds: contactListId.slice(1),
                eventTracking: subscribeCookie({
                    sector_name: t('D_btn'),
                    entry_position: 4,
                }),
            },
            {
                headers: {
                    apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
                },
            },
        );
        if (res?.code === '0') {
            setTip(t('D_tip_success'));
            setInput('');
            setTimeout(() => {
                setTip('');
            }, 3000);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('D_btn'),
                status: 'success',
                product_name: 'EcoFlow DELTA Pro Ultra X',
                tag: 'Agree',

                __btn_id1: 'dpux-D .subscribe .btn',
                __btn_id2: t('D_btn'),
                __btn_type: 'text',
            });
        } else {
            setTip(t('D_tip_fail'));
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('D_btn'),
                status: 'fail',
                tag: 'Agree',

                product_name: 'EcoFlow DELTA Pro Ultra X',
                __btn_id1: 'dpux-D .subscribe .btn',
                __btn_id2: t('D_btn'),
                __btn_type: 'text',
            });
            throw new Error(res?.message);
        }
    };

    const handleOpenModal = () => {
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('title'),
            button_name: t('D_memo'),
            __btn_id1: 'dpux-D .memo-ani .memo',
            __btn_id2: `- ${t('D_memo')} -`,
            __btn_type: 'text',
        });
    };

    const handleCloseModal = () => {
        setVisible(false);
    };

    const handleCloseItems = () => {
        setVisibleItems(-1);
    };

    const handleClickItem = (item: ItemType, k: number) => {
        setVisibleItems(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: item.text,
            button_name: '?',

            __btn_id1: `D-items-ani .item-${k}`,
            __btn_id2: `dpux-D-card-${k}`,
            __btn_type: 'common',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
            const sceneDArr: any[] = [];
            const domClass = [
                '.delta-pro-ultra-x-D .title-ani',
                '.delta-pro-ultra-x-D .countdown-ani',
                '.delta-pro-ultra-x-D .control-ani',
                '.delta-pro-ultra-x-D .DepositNowBtn',
                '.delta-pro-ultra-x-D .memo-ani',
            ];
            const doms = domClass.map((item) => document.querySelector(item));
            const items = document.querySelectorAll('.delta-pro-ultra-x-D .items-ani .items .item');

            let timers: any = [];
            sceneDArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-D .info',
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        doms.forEach((item) => {
                            if (item) {
                                item?.classList?.add?.('enter');
                            }
                        });
                        items &&
                            items.forEach((item, idx) => {
                                const id = setTimeout(() => {
                                    item.classList.add?.('enter');
                                }, 600 + 60 * idx);
                                timers.push(id);
                            });
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            doms.forEach((item) => {
                                if (item) {
                                    item?.classList?.remove?.('enter');
                                }
                            });
                            // 清掉所有未执行的 timeout，避免副作用
                            timers.forEach((id: any) => clearTimeout(id));
                            timers = [];
                            items &&
                                items.forEach((item) => {
                                    item?.classList?.remove?.('enter');
                                });
                        }
                    },
                }),
            );
            return () => {
                sceneDArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-D dpux-D GtmModuleData-section`}
            id="delta-pro-ultra-x-D"
            data-section-id={'delta-pro-ultra-x-D'}
            data-section-title={t(`D_title_${pageStatus?.toLowerCase()}`)}
        >
            <div className="info">
                <div className="title-ani">
                    <p className={`title`}>
                        {t.rich(`D_title_${pageStatus?.toLowerCase()}`, {
                            span: (v: string) => <span>{v}</span>,
                        })}
                    </p>
                    {t(`D_desc_${pageStatus?.toLowerCase()}`) && <p className={`desc`}>{t(`D_desc_${pageStatus?.toLowerCase()}`)}</p>}
                </div>
                <div className="countdown-ani">
                    <div className={`countdown`}>
                        <EcoCountDown endTime={countDownEnd} />
                        <ul className="suffix-items">
                            {['d', 'h', 'm', 's'].map((item) => (
                                <li className="suffix-item" key={item}>
                                    <p className="suffix">{t(`D_countdown_${item}`)}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {[IPageStatus.TEASER, IPageStatus.SUPER_EARLY].includes(pageStatus) && (
                    <div className="control-ani">
                        <div className={`control`}>
                            <div className="subscribe">
                                <input
                                    type="text"
                                    className="input"
                                    id="dpux-D-input"
                                    placeholder={t('D_placeholder')}
                                    value={input}
                                    onChange={handleInput}
                                    onFocus={handleFoucus}
                                />
                                <p className={`tip${tip ? ' show' : ''}${tip === t('D_tip_success') ? ' success' : ''}`}>{tip}</p>
                                <button className="btn GtmModuleData-btn-text" onClick={handleSubmit}>
                                    {t('D_btn')}
                                </button>
                            </div>
                            <div className="terms">
                                <input
                                    type="checkbox"
                                    className="checkbox GtmModuleData-btn-common"
                                    id="dpux-D-checkbox"
                                    checked={checked}
                                    data-btn-id="dpux-D-checkbox"
                                    onChange={(e) => {
                                        gtm.push({
                                            __btn_id1: `${css.section} .checkbox`,
                                            __btn_id2: `dpux-D-checkbox`,
                                            __btn_type: 'common',
                                        });
                                        handleCheck(e);
                                    }}
                                />
                                <label className="terms-text" htmlFor="dpux-D-checkbox">
                                    {t.rich('D_terms', {
                                        l1: (termsOfUse: string) => (
                                            <EcoLink
                                                className="terms-text-href1 GtmModuleData-btn-href"
                                                dataLayer={{
                                                    __btn_id1: `${css.section} .terms-text-href1`,
                                                    __btn_id2: termsMap[locale][1],
                                                    __btn_type: 'href',
                                                }}
                                                href={termsMap[locale][1]}
                                                target="_blank"
                                            >
                                                {termsOfUse}
                                            </EcoLink>
                                        ),
                                        l2: (privacyPolicy: string) => (
                                            <EcoLink
                                                className="terms-text-href2 GtmModuleData-btn-href"
                                                dataLayer={{
                                                    __btn_id1: `${css.section} .terms-text-href2`,
                                                    __btn_id2: termsMap[locale][0],
                                                    __btn_type: 'href',
                                                }}
                                                href={termsMap[locale][0]}
                                                target="_blank"
                                            >
                                                {privacyPolicy}
                                            </EcoLink>
                                        ),
                                    })}
                                </label>
                            </div>
                        </div>
                    </div>
                )}
                <div className="items-ani D-items-ani">
                    <ul className={`items ${pageStatus.toLowerCase()} ${locale}`}>
                        {items.map((item: any, k: number) => (
                            <li
                                className={`item GtmModuleData-btn-common item-${k}`}
                                key={item.text}
                                data-btn-id={`dpux-D-card-${k}`}
                                style={{ gridArea: `g${k + 1}` }}
                                onClick={() => handleClickItem(item, k)}
                            >
                                <EcoImg className="item-img" pc={webpOrJpg(item.img[0])} pad={webpOrJpg(item.img[0])} h5={webpOrJpg(item.img[1])} />
                                <p className="item-text">{item.text}</p>
                                <svg
                                    className={`item-icon item-icon-${k}`}
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M16 1.3335C24.1002 1.3335 30.667 7.90031 30.667 16.0005C30.6667 24.1004 24.1 30.6665 16 30.6665C7.89999 30.6665 1.33327 24.1004 1.33301 16.0005C1.33301 7.90031 7.89982 1.3335 16 1.3335ZM16 22.9263C15.325 22.9263 14.7774 23.473 14.7773 24.1479C14.7773 24.823 15.325 25.3706 16 25.3706H16.0156C16.6906 25.3705 17.2373 24.8229 17.2373 24.1479C17.2373 23.473 16.6906 22.9263 16.0156 22.9263H16ZM16.9023 6.71045C15.4801 6.4666 14.0175 6.7333 12.7734 7.46436C11.5293 8.19557 10.5834 9.34421 10.1045 10.7056C9.8808 11.3422 10.216 12.0402 10.8525 12.2642C11.4892 12.4879 12.1872 12.1527 12.4111 11.5161C12.6985 10.6995 13.2653 10.0104 14.0117 9.57178C14.7582 9.13311 15.6359 8.97332 16.4893 9.11963C17.3426 9.266 18.1172 9.70924 18.6748 10.3716C19.2324 11.034 19.5374 11.8729 19.5361 12.7388V12.7407C19.536 13.7214 18.784 14.6246 17.6357 15.3901C17.0989 15.748 16.5529 16.0216 16.1367 16.2065C15.9305 16.2982 15.7603 16.3665 15.6445 16.4106C15.5868 16.4326 15.5424 16.4486 15.5146 16.4585C15.5011 16.4633 15.4917 16.4674 15.4863 16.4692C15.4841 16.47 15.4822 16.47 15.4814 16.4702H15.4824C14.9838 16.6368 14.6475 17.1037 14.6475 17.6294V20.0737C14.6475 20.7487 15.1951 21.2964 15.8701 21.2964C16.5449 21.2961 17.0918 20.7486 17.0918 20.0737V18.4565C17.1042 18.4511 17.1173 18.4465 17.1299 18.4409C17.6303 18.2185 18.307 17.8811 18.9922 17.4243C20.2478 16.5873 21.8752 15.1144 21.9756 12.9517L21.9805 12.7407C21.9822 11.2981 21.474 9.90102 20.5449 8.79736C19.6155 7.69338 18.3247 6.95442 16.9023 6.71045Z"
                                        fill="#010101"
                                    />
                                    <g opacity="0.8">
                                        <path
                                            d="M11.2578 11.1108C11.6409 10.0217 12.3972 9.10326 13.3926 8.51827C14.3879 7.93327 15.5582 7.71943 16.6962 7.91462C17.8341 8.10981 18.8663 8.70142 19.6098 9.58469C20.3533 10.468 20.7603 11.5859 20.7586 12.7404C20.7586 15.9997 15.8697 17.6293 15.8697 17.6293V20.0738"
                                            stroke="white"
                                            strokeWidth="2.44444"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M16.0155 22.9258C16.6905 22.9258 17.2377 23.473 17.2377 24.148C17.2377 24.823 16.6905 25.3702 16.0155 25.3702H15.9996C15.3246 25.3702 14.7773 24.823 14.7773 24.148C14.7773 23.473 15.3246 22.9258 15.9996 22.9258H16.0155Z"
                                            fill="white"
                                        />
                                    </g>
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>
                {pageStatus === IPageStatus.TEASER && (
                    <EcoLink
                        className="DepositNowBtn GtmModuleData-btn-href"
                        href={saveCookieForShopify(t('D_item1_modal_btn_link_teaser'), locale)}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'checkout',
                            button_name: `Super-Early-Bird Offer_EcoFlow DELTA Pro Ultra X`,
                            display_type: 'none',
                            module_referral: 'none',
                            jump_module: 'none',
                            __btn_id1: 'dpux-D .DepositNowBtn',
                            __btn_id2: t('D_item1_modal_btn_link_teaser'),
                            __btn_type: 'href',
                        }}
                    >
                        {t('D_item1_modal_btn_text_teaser')}
                    </EcoLink>
                )}
                <div className="memo-ani">
                    <span className={`memo GtmModuleData-btn-text`} onClick={handleOpenModal}>
                        {`- ${t('D_memo')} -`}
                    </span>
                </div>
            </div>
            {isClient && visible && createPortal(<Modal callback={handleCloseModal} />, document.body)}
            {isClient &&
                visibleItems >= 0 &&
                createPortal(
                    <ModalItems
                        setActivetedTabs={setActivetedTabs}
                        data={items[visibleItems].modal}
                        index={items[visibleItems].key}
                        callback={handleCloseItems}
                    />,
                    document.body,
                )}
        </section>
    );
};

export default D;
